module.exports = __webpack_public_path__ + "static/media/JackLinks-Sasquatch.bdd4d14d.jpg";